export default __webpack_public_path__ + "static/media/dacre-stoker-headshot.112bff1c.png";